// All admin API calls

const API_BASE = '/api/admin';

const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}`,
});

const handleResponse = async (res) => {
  const data = await res.json();
  if (res.status === 401) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin/login';
  }
  return data;
};

// ─── AUTH ────────────────────────────────────────────────
export const adminLogin = async (email, password) => {
  const res = await fetch(`${API_BASE}/auth.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
};

export const adminLogout = async () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
  window.location.href = '/admin/login';
};

// ─── DASHBOARD ──────────────────────────────────────────
export const getDashboard = async () => {
  const res = await fetch(`${API_BASE}/dashboard.php`, { headers: getHeaders() });
  return handleResponse(res);
};

// ─── SLIDERS ────────────────────────────────────────────
export const adminGetSliders = async () => {
  const res = await fetch(`${API_BASE}/sliders.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddSlider = async (formData) => {
  const res = await fetch(`${API_BASE}/sliders.php`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminUpdateSlider = async (data) => {
  const res = await fetch(`${API_BASE}/sliders.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

export const adminDeleteSlider = async (id) => {
  const res = await fetch(`${API_BASE}/sliders.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── SERVICES ───────────────────────────────────────────
export const adminGetServices = async () => {
  const res = await fetch(`${API_BASE}/services.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddService = async (formData) => {
  const res = await fetch(`${API_BASE}/services.php`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminUpdateService = async (data) => {
  const res = await fetch(`${API_BASE}/services.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

export const adminDeleteService = async (id) => {
  const res = await fetch(`${API_BASE}/services.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── PROJECTS ───────────────────────────────────────────
export const adminGetProjects = async () => {
  const res = await fetch(`${API_BASE}/projects.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddProject = async (formData) => {
  const res = await fetch(`${API_BASE}/projects.php`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminUpdateProject = async (formData) => {
  formData.append('_method', 'PUT');
  const res = await fetch(`${API_BASE}/projects.php`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminDeleteProject = async (id) => {
  const res = await fetch(`${API_BASE}/projects.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── PRODUCTS ───────────────────────────────────────────
export const adminGetProducts = async () => {
  const res = await fetch(`${API_BASE}/products.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddProduct = async (formData) => {
  const res = await fetch(`${API_BASE}/products.php`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminUpdateProduct = async (data) => {
  const res = await fetch(`${API_BASE}/products.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

export const adminDeleteProduct = async (id) => {
  const res = await fetch(`${API_BASE}/products.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── GALLERY ────────────────────────────────────────────
export const adminGetGallery = async () => {
  const res = await fetch(`${API_BASE}/gallery.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddGallery = async (formData) => {
  const res = await fetch(`${API_BASE}/gallery.php`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token') || ''}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminDeleteGallery = async (id) => {
  const res = await fetch(`${API_BASE}/gallery.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── TESTIMONIALS ───────────────────────────────────────
export const adminGetTestimonials = async () => {
  const res = await fetch(`${API_BASE}/testimonials.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddTestimonial = async (formData) => {
  const token = localStorage.getItem('admin_token');
  const res = await fetch(`${API_BASE}/testimonials.php`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminUpdateTestimonial = async (data) => {
  const res = await fetch(`${API_BASE}/testimonials.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

export const adminDeleteTestimonial = async (id) => {
  const res = await fetch(`${API_BASE}/testimonials.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── SETTINGS ───────────────────────────────────────────
export const adminGetSettings = async () => {
  const res = await fetch(`${API_BASE}/settings.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminUpdateSettings = async (data) => {
  const res = await fetch(`${API_BASE}/settings.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

// ─── CLIENTS ────────────────────────────────────────────
export const adminGetClients = async () => {
  const res = await fetch(`${API_BASE}/clients.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddClient = async (formData) => {
  const token = localStorage.getItem('admin_token');
  const res = await fetch(`${API_BASE}/clients.php`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  return handleResponse(res);
};

export const adminUpdateClient = async (data) => {
  const res = await fetch(`${API_BASE}/clients.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

export const adminDeleteClient = async (id) => {
  const res = await fetch(`${API_BASE}/clients.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── CLIENT IMAGE GALLERY ───────────────────────────────
export const adminGetClientImages = async (clientId) => {
  const res = await fetch(`${API_BASE}/client_images.php?client_id=${clientId}`, { headers: getHeaders() });
  return handleResponse(res);
};

// files: array of File objects, captions: array of strings (same length, can be empty strings)
export const adminUploadClientImages = async (clientId, files, captions = []) => {
  const token = localStorage.getItem('admin_token');
  const fd = new FormData();
  fd.append('client_id', clientId);
  files.forEach((file) => fd.append('images[]', file));
  files.forEach((_, i) => fd.append('captions[]', captions[i] || ''));

  const res = await fetch(`${API_BASE}/client_images.php`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: fd,
  });
  return handleResponse(res);
};

export const adminUpdateClientImage = async (id, caption, sortOrder) => {
  const res = await fetch(`${API_BASE}/client_images.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ id, caption, sort_order: sortOrder }),
  });
  return handleResponse(res);
};

export const adminDeleteClientImage = async (id) => {
  const res = await fetch(`${API_BASE}/client_images.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── INQUIRIES ──────────────────────────────────────────
export const adminGetInquiries = async () => {
  const res = await fetch(`${API_BASE}/inquiries.php`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminUpdateInquiryStatus = async (id, status) => {
  const res = await fetch(`${API_BASE}/inquiries.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ id, status }),
  });
  return handleResponse(res);
};

export const adminDeleteInquiry = async (id) => {
  const res = await fetch(`${API_BASE}/inquiries.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// ─── INQUIRY NOTES ──────────────────────────────────────
export const adminGetInquiryNotes = async (inquiryId) => {
  const res = await fetch(`${API_BASE}/inquiry_notes.php?inquiry_id=${inquiryId}`, { headers: getHeaders() });
  return handleResponse(res);
};

export const adminAddInquiryNote = async (inquiryId, adminId, note) => {
  const res = await fetch(`${API_BASE}/inquiry_notes.php`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ inquiry_id: inquiryId, admin_id: adminId, note }),
  });
  return handleResponse(res);
};

export const adminDeleteInquiryNote = async (id) => {
  const res = await fetch(`${API_BASE}/inquiry_notes.php`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ id }),
  });
  return handleResponse(res);
};

// Schedule (or reschedule) a follow-up reminder. followUpAt: 'YYYY-MM-DDTHH:MM' from a datetime-local input.
export const adminSetInquiryFollowUp = async (id, followUpAt, note) => {
  const res = await fetch(`${API_BASE}/inquiries.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ id, follow_up_at: followUpAt, follow_up_note: note || '' }),
  });
  return handleResponse(res);
};

// Clear a scheduled follow-up entirely
export const adminClearInquiryFollowUp = async (id) => {
  const res = await fetch(`${API_BASE}/inquiries.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ id, follow_up_at: '' }),
  });
  return handleResponse(res);
};

// Mark a follow-up reminder as done (without deleting the schedule)
export const adminMarkFollowUpDone = async (id) => {
  const res = await fetch(`${API_BASE}/inquiries.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ id, follow_up_done: 1 }),
  });
  return handleResponse(res);
};

// Snooze — reschedule follow_up_at by N minutes from now
export const adminSnoozeInquiryFollowUp = async (id, minutesFromNow) => {
  const dt = new Date(Date.now() + minutesFromNow * 60000);
  const pad = (n) => String(n).padStart(2, '0');
  const followUpAt = `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
  const res = await fetch(`${API_BASE}/inquiries.php`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ id, follow_up_at: followUpAt }),
  });
  return handleResponse(res);
};